import { render, staticRenderFns } from "./PostFacilitiesDialog.vue?vue&type=template&id=ff70df18&scoped=true&"
import script from "./PostFacilitiesDialog.vue?vue&type=script&lang=js&"
export * from "./PostFacilitiesDialog.vue?vue&type=script&lang=js&"
import style0 from "./PostFacilitiesDialog.vue?vue&type=style&index=0&id=ff70df18&lang=scss&scoped=true&"
import style1 from "./PostFacilitiesDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff70df18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VCol,VIcon,VListItem,VListItemContent,VRow,VTextField,VVirtualScroll})
